import React, { useState } from "react";
import { FaUsers, FaEye } from "react-icons/fa";
import AdminVisitors from "./AdminVisitors";
import AdminUsers from "./AdminUsers";

const AdminHome = () => {
  const [activeTab, setActiveTab] = useState("visitors"); // Default to visitors tab

  return (
    <div className="min-h-[100dvh] bg-gray-100 p-6">
      <div className="max-w-6xl mx-auto bg-white shadow-lg rounded-lg p-6">
        {/* Dashboard Header */}
        <h1 className="text-3xl font-bold text-gray-800 mb-6 text-center">
          Admin Dashboard
        </h1>

        {/* Tab Navigation */}
        <div className="flex border-b mb-6">
          <button
            className={`flex-1 py-3 text-lg font-semibold transition duration-300 ${
              activeTab === "visitors"
                ? "border-b-4 border-blue-500 text-blue-500"
                : "text-gray-600 hover:text-blue-500"
            }`}
            onClick={() => setActiveTab("visitors")}
          >
            <FaEye className="inline-block mr-2" /> Visitors
          </button>
          <button
            className={`flex-1 py-3 text-lg font-semibold transition duration-300 ${
              activeTab === "users"
                ? "border-b-4 border-blue-500 text-blue-500"
                : "text-gray-600 hover:text-blue-500"
            }`}
            onClick={() => setActiveTab("users")}
          >
            <FaUsers className="inline-block mr-2" /> Users
          </button>
        </div>

        {/* Tab Content */}
        <div className="mt-4">
          {activeTab === "visitors" && <AdminVisitors />}
          {activeTab === "users" && <AdminUsers />}
        </div>
      </div>
    </div>
  );
};

export default AdminHome;